import { ArrowLeft, ArrowRight } from 'lucide-react';

interface ChatActivityPagerProps {
  index: number;
  count: number;
  onIndexChange: (index: number) => void;
  previousLabel: string;
  nextLabel: string;
  /** Where the reader is among the step's items, e.g. "2 van 4". */
  positionLabel: (position: number, count: number) => string;
}

const PAGER =
  'flex cursor-pointer items-center gap-1 rounded-sm border border-line px-2.5 py-1.25 text-sm text-ink-secondary hover:bg-fill aria-disabled:cursor-default aria-disabled:opacity-40 aria-disabled:hover:bg-transparent focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ink-faint';

/** Steps to the other items of the same step in the activity panel. */
export function ChatActivityPager({
  index,
  count,
  onIndexChange,
  previousLabel,
  nextLabel,
  positionLabel,
}: ChatActivityPagerProps) {
  const first = index === 0;
  const last = index === count - 1;

  return (
    <div className='mt-4 flex items-center gap-1.5'>
      <button
        type='button'
        aria-disabled={first}
        onClick={() => !first && onIndexChange(index - 1)}
        className={PAGER}
      >
        <ArrowLeft size={13} aria-hidden='true' />
        {previousLabel}
      </button>
      <button
        type='button'
        aria-disabled={last}
        onClick={() => !last && onIndexChange(index + 1)}
        className={PAGER}
      >
        {nextLabel}
        <ArrowRight size={13} aria-hidden='true' />
      </button>
      <span aria-live='polite' className='ml-1.5 text-sm text-ink-muted'>
        {positionLabel(index + 1, count)}
      </span>
    </div>
  );
}
